import React, { useState } from "react";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { UrlApi } from "../../../services/apirest";
import { COLOR_MARCA } from "./constantes";

// Confirmación y envío a facturar (mismo endpoint que la V1). El resultado se muestra en el diálogo.
// onClose(huboEnvio): avisa si se envió, para recargar la lista.
function DialogFacturar({ pedido, onClose }) {
  const [enviando, setEnviando] = useState(false);
  const [resultado, setResultado] = useState(null); // { ok, mensaje }

  const facturar = async () => {
    setEnviando(true);
    try {
      const respuesta = await fetch(UrlApi + "/pedidos/facturar/" + pedido.id_pedido);
      const json = await respuesta.json().catch(() => ({}));
      setResultado({
        ok: respuesta.ok,
        mensaje: json.message || (respuesta.ok ? "Pedido enviado a facturar." : "No se pudo facturar el pedido."),
      });
    } catch (e) {
      setResultado({ ok: false, mensaje: "Error de conexión. No se pudo enviar a facturar." });
    } finally {
      setEnviando(false);
    }
  };

  const cerrar = () => {
    if (!enviando) onClose(!!resultado);
  };

  return (
    <Dialog open onClose={cerrar} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ bgcolor: COLOR_MARCA, color: "#fff" }}>Facturar pedido #{pedido.id_pedido}</DialogTitle>
      <DialogContent sx={{ pt: "16px !important" }}>
        {resultado ? (
          <Alert severity={resultado.ok ? "success" : "error"}>{resultado.mensaje}</Alert>
        ) : (
          <DialogContentText>
            ¿Confirmás que querés enviar a facturar el pedido de <b>{pedido.cliente}</b>
            {pedido.nro_remito ? ` (remito ${pedido.nro_remito})` : ""}?
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        {resultado ? (
          <Button onClick={cerrar} variant="contained">
            Cerrar
          </Button>
        ) : (
          <>
            <Button onClick={cerrar} disabled={enviando}>
              Cancelar
            </Button>
            <Button
              onClick={facturar}
              variant="contained"
              color="success"
              disabled={enviando}
              startIcon={enviando ? <CircularProgress size={16} color="inherit" /> : null}
            >
              {enviando ? "Enviando..." : "Facturar"}
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
}

export default DialogFacturar;
